import React, { useEffect, useRef, useState } from "react";
import CoachLayout from "../../layouts/CoachLayout";
import MenuLayout from "../../layouts/MenuLayout";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { fetchCoachCategories } from "../../redux/features/coach/actions/authAction";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { curSym } from "../../utils/pip";
const JobDetail = () => {
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const { categoryList, isLoading } = useSelector((state) => state.coach.auth);

  const user = { name: "find-a-coach", role: "coach" };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();

  const [searchByName, setSearchByName] = useState("");
  const [searchByCoachingType, setSearchByCoachingType] = useState(
    state?.data ?? ""
  );

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
    dispatch(fetchCoachCategories());
  }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchSearchName =
      !searchByName ||
      item?.full_name?.toLowerCase().includes(searchByName.toLowerCase());
    const matchCoachingType =
      !searchByCoachingType ||
      item?.category_name
        ?.toLowerCase()
        .includes(searchByCoachingType.toLowerCase());
    return matchCoachingType && matchSearchName;
  });

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <MenuLayout user={user}>
        <section
          class="ct_px_40    ct_pt_40_pb_32"
          style={{ backgroundColor: "var(--dark_blue)" }}
        >
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-xxl-12 col-xl-12 "
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                <div className="ct_leaning_banner_grid">
                  <div>
                    <img
                      src="../assets/img/job_detail_left_banner_img.png"
                      className="ct_img_h_240"
                    />
                  </div>
                  <div className="text-center ct_middle_learning_center">
                    <h2 className="ct_fs_40 text-white mb-0">
                      UI/UX Design
                    </h2>
                  </div>
                  <div className="mt-auto">
                    <img
                      src="../assets/img/job_detail_right_banner_img.png"
                      className="ct_img_h_240"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ct_px_40 ct_pb_100 pt-5">
          <div className="container-fluid">


            <div className=" mb-0 ct_nuglow_yellow_shape_main_34 ct_job_list__shape_main_123 ct_pt_90 ">

              <div className="row gx-5">
                <div className="col-lg-6 ct_mb_60">
                  <div className="ct_learning_card_learning">
                    <figure className="mb-0">
                      <div className="d-flex align-items-center gap-2 justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <div className="ct_feature_job_icon bg-white">
                            <img src="../assets/img/Featured_Jobs_icon_3.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                              CodeNest
                            </h4>
                            <p className="d-flex align-items-center gap-2 mb-0 ct_fs_14 ct_darkblue_text">
                              <svg
                                width="14"
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                  fill="#023047"
                                />
                              </svg>
                              London, England
                            </p>
                          </div>
                        </div>
                        <div className="pe-xl-5">
                          <button
                            className="ct_badge ct_border_radius_5 border-0 ct_white_nowrap"
                            style={{ backgroundColor: "#FFB703" }}
                          >
                            Full-Time
                          </button>
                        </div>
                      </div>
                      <figcaption className="ct_mt_30">
                        <h4
                          className="ct_fs_20 mb-3 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Senior full stack engineer, User onboarding
                        </h4>
                        <p className="mb-0" style={{ maxWidth: "365px" }}>
                          Drive seamless first impressions by building
                          intuitive onboarding flows that convert.
                        </p>

                        <div className="d-flex align-items-center gap-2 pt-3 justify-content-between">
                          <div>
                            <ul>
                              <li className="d-flex align-items-center gap-2">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                UI/UX Design
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                    fill="#023047"
                                  />
                                </svg>
                                3-5 years
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.4375 5.88477C7.7355 6.07677 7.3125 6.61602 7.3125 7.12452C7.3125 7.63302 7.7355 8.17227 8.4375 8.36352V5.88477ZM9.5625 9.63552V12.1135C10.2645 11.9223 10.6875 11.383 10.6875 10.8745C10.6875 10.366 10.2645 9.82677 9.5625 9.63552Z"
                                    fill="#023047"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9ZM9 3.9375C9.14918 3.9375 9.29226 3.99676 9.39775 4.10225C9.50324 4.20774 9.5625 4.35082 9.5625 4.5V4.73775C10.785 4.95675 11.8125 5.8755 11.8125 7.125C11.8125 7.27418 11.7532 7.41726 11.6477 7.52275C11.5423 7.62824 11.3992 7.6875 11.25 7.6875C11.1008 7.6875 10.9577 7.62824 10.8523 7.52275C10.7468 7.41726 10.6875 7.27418 10.6875 7.125C10.6875 6.6165 10.2645 6.07725 9.5625 5.88525V8.48775C10.785 8.70675 11.8125 9.6255 11.8125 10.875C11.8125 12.1245 10.785 13.0433 9.5625 13.2623V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V13.2623C7.215 13.0433 6.1875 12.1245 6.1875 10.875C6.1875 10.7258 6.24676 10.5827 6.35225 10.4773C6.45774 10.3718 6.60082 10.3125 6.75 10.3125C6.89918 10.3125 7.04226 10.3718 7.14775 10.4773C7.25324 10.5827 7.3125 10.7258 7.3125 10.875C7.3125 11.3835 7.7355 11.9228 8.4375 12.114V9.51225C7.215 9.29325 6.1875 8.3745 6.1875 7.125C6.1875 5.8755 7.215 4.95675 8.4375 4.73775V4.5C8.4375 4.35082 8.49676 4.20774 8.60225 4.10225C8.70774 3.99676 8.85082 3.9375 9 3.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                {curSym} 5k to {curSym} 6k USD
                              </li>
                            </ul>
                          </div>
                          <div className="pe-xl-5">
                            <p className="mb-0 ct_fs_14 ct_darkblue_text">
                              24 March 2025
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                          <button
                            className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 px-4"
                            data-bs-target="#ct_job_details_modal"
                            data-bs-toggle="modal"
                          >
                            Apply Now
                          </button>
                          <div className="ct_icon_heart_50">
                            <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                          </div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div className="col-lg-6 ct_mb_60">
                  <div className="ct_learning_card_learning">
                    <figure className="mb-0">
                      <div className="d-flex align-items-center gap-2 justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <div className="ct_feature_job_icon bg-white">
                            <img src="../assets/img/Featured_Jobs_icon_6.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                              CodeNest
                            </h4>
                            <p className="d-flex align-items-center gap-2 mb-0 ct_fs_14 ct_darkblue_text">
                              <svg
                                width="14"
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                  fill="#023047"
                                />
                              </svg>
                              London, England
                            </p>
                          </div>
                        </div>
                        <div className="pe-xl-5">
                          <button
                            className="ct_badge ct_border_radius_5 border-0 ct_white_nowrap"
                            style={{ backgroundColor: "#FFB703" }}
                          >
                            Full-Time
                          </button>
                        </div>
                      </div>
                      <figcaption className="ct_mt_30">
                        <h4
                          className="ct_fs_20 mb-3 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Senior full stack engineer, User onboarding
                        </h4>
                        <p className="mb-0" style={{ maxWidth: "365px" }}>
                          Drive seamless first impressions by building
                          intuitive onboarding flows that convert.
                        </p>

                        <div className="d-flex align-items-center gap-2 pt-3 justify-content-between">
                          <div>
                            <ul>
                              <li className="d-flex align-items-center gap-2">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                UI/UX Design
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                    fill="#023047"
                                  />
                                </svg>
                                3-5 years
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.4375 5.88477C7.7355 6.07677 7.3125 6.61602 7.3125 7.12452C7.3125 7.63302 7.7355 8.17227 8.4375 8.36352V5.88477ZM9.5625 9.63552V12.1135C10.2645 11.9223 10.6875 11.383 10.6875 10.8745C10.6875 10.366 10.2645 9.82677 9.5625 9.63552Z"
                                    fill="#023047"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9ZM9 3.9375C9.14918 3.9375 9.29226 3.99676 9.39775 4.10225C9.50324 4.20774 9.5625 4.35082 9.5625 4.5V4.73775C10.785 4.95675 11.8125 5.8755 11.8125 7.125C11.8125 7.27418 11.7532 7.41726 11.6477 7.52275C11.5423 7.62824 11.3992 7.6875 11.25 7.6875C11.1008 7.6875 10.9577 7.62824 10.8523 7.52275C10.7468 7.41726 10.6875 7.27418 10.6875 7.125C10.6875 6.6165 10.2645 6.07725 9.5625 5.88525V8.48775C10.785 8.70675 11.8125 9.6255 11.8125 10.875C11.8125 12.1245 10.785 13.0433 9.5625 13.2623V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V13.2623C7.215 13.0433 6.1875 12.1245 6.1875 10.875C6.1875 10.7258 6.24676 10.5827 6.35225 10.4773C6.45774 10.3718 6.60082 10.3125 6.75 10.3125C6.89918 10.3125 7.04226 10.3718 7.14775 10.4773C7.25324 10.5827 7.3125 10.7258 7.3125 10.875C7.3125 11.3835 7.7355 11.9228 8.4375 12.114V9.51225C7.215 9.29325 6.1875 8.3745 6.1875 7.125C6.1875 5.8755 7.215 4.95675 8.4375 4.73775V4.5C8.4375 4.35082 8.49676 4.20774 8.60225 4.10225C8.70774 3.99676 8.85082 3.9375 9 3.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                {curSym} 5k to {curSym} 6k USD
                              </li>
                            </ul>
                          </div>
                          <div className="pe-xl-5">
                            <p className="mb-0 ct_fs_14 ct_darkblue_text">
                              24 March 2025
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                          <button
                            className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 px-4"
                            data-bs-target="#ct_job_details_modal"
                            data-bs-toggle="modal"
                          >
                            Apply Now
                          </button>
                          <div className="ct_icon_heart_50">
                            <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                          </div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div className="col-lg-6 ct_mb_60">
                  <div className="ct_learning_card_learning">
                    <figure className="mb-0">
                      <div className="d-flex align-items-center gap-2 justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <div className="ct_feature_job_icon bg-white">
                            <img src="../assets/img/Featured_Jobs_icon_6.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                              CodeNest
                            </h4>
                            <p className="d-flex align-items-center gap-2 mb-0 ct_fs_14 ct_darkblue_text">
                              <svg
                                width="14"
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                  fill="#023047"
                                />
                              </svg>
                              London, England
                            </p>
                          </div>
                        </div>
                        <div className="pe-xl-5">
                          <button
                            className="ct_badge ct_border_radius_5 border-0 ct_white_nowrap"
                            style={{ backgroundColor: "#FFB703" }}
                          >
                            Full-Time
                          </button>
                        </div>
                      </div>
                      <figcaption className="ct_mt_30">
                        <h4
                          className="ct_fs_20 mb-3 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Senior full stack engineer, User onboarding
                        </h4>
                        <p className="mb-0" style={{ maxWidth: "365px" }}>
                          Drive seamless first impressions by building
                          intuitive onboarding flows that convert.
                        </p>

                        <div className="d-flex align-items-center gap-2 pt-3 justify-content-between">
                          <div>
                            <ul>
                              <li className="d-flex align-items-center gap-2">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                UI/UX Design
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                    fill="#023047"
                                  />
                                </svg>
                                3-5 years
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.4375 5.88477C7.7355 6.07677 7.3125 6.61602 7.3125 7.12452C7.3125 7.63302 7.7355 8.17227 8.4375 8.36352V5.88477ZM9.5625 9.63552V12.1135C10.2645 11.9223 10.6875 11.383 10.6875 10.8745C10.6875 10.366 10.2645 9.82677 9.5625 9.63552Z"
                                    fill="#023047"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9ZM9 3.9375C9.14918 3.9375 9.29226 3.99676 9.39775 4.10225C9.50324 4.20774 9.5625 4.35082 9.5625 4.5V4.73775C10.785 4.95675 11.8125 5.8755 11.8125 7.125C11.8125 7.27418 11.7532 7.41726 11.6477 7.52275C11.5423 7.62824 11.3992 7.6875 11.25 7.6875C11.1008 7.6875 10.9577 7.62824 10.8523 7.52275C10.7468 7.41726 10.6875 7.27418 10.6875 7.125C10.6875 6.6165 10.2645 6.07725 9.5625 5.88525V8.48775C10.785 8.70675 11.8125 9.6255 11.8125 10.875C11.8125 12.1245 10.785 13.0433 9.5625 13.2623V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V13.2623C7.215 13.0433 6.1875 12.1245 6.1875 10.875C6.1875 10.7258 6.24676 10.5827 6.35225 10.4773C6.45774 10.3718 6.60082 10.3125 6.75 10.3125C6.89918 10.3125 7.04226 10.3718 7.14775 10.4773C7.25324 10.5827 7.3125 10.7258 7.3125 10.875C7.3125 11.3835 7.7355 11.9228 8.4375 12.114V9.51225C7.215 9.29325 6.1875 8.3745 6.1875 7.125C6.1875 5.8755 7.215 4.95675 8.4375 4.73775V4.5C8.4375 4.35082 8.49676 4.20774 8.60225 4.10225C8.70774 3.99676 8.85082 3.9375 9 3.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                {curSym} 5k to {curSym} 6k USD
                              </li>
                            </ul>
                          </div>
                          <div className="pe-xl-5">
                            <p className="mb-0 ct_fs_14 ct_darkblue_text">
                              24 March 2025
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                          <button
                            className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 px-4"
                            data-bs-target="#ct_job_details_modal"
                            data-bs-toggle="modal"
                          >
                            Apply Now
                          </button>
                          <div className="ct_icon_heart_50">
                            <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                          </div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div className="col-lg-6 ct_mb_60">
                  <div className="ct_learning_card_learning">
                    <figure className="mb-0">
                      <div className="d-flex align-items-center gap-2 justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <div className="ct_feature_job_icon bg-white">
                            <img src="../assets/img/Featured_Jobs_icon_3.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                              CodeNest
                            </h4>
                            <p className="d-flex align-items-center gap-2 mb-0 ct_fs_14 ct_darkblue_text">
                              <svg
                                width="14"
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                  fill="#023047"
                                />
                              </svg>
                              London, England
                            </p>
                          </div>
                        </div>
                        <div className="pe-xl-5">
                          <button
                            className="ct_badge ct_border_radius_5 border-0 ct_white_nowrap"
                            style={{ backgroundColor: "#FFB703" }}
                          >
                            Full-Time
                          </button>
                        </div>
                      </div>
                      <figcaption className="ct_mt_30">
                        <h4
                          className="ct_fs_20 mb-3 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Senior full stack engineer, User onboarding
                        </h4>
                        <p className="mb-0" style={{ maxWidth: "365px" }}>
                          Drive seamless first impressions by building
                          intuitive onboarding flows that convert.
                        </p>

                        <div className="d-flex align-items-center gap-2 pt-3 justify-content-between">
                          <div>
                            <ul>
                              <li className="d-flex align-items-center gap-2">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                UI/UX Design
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                    fill="#023047"
                                  />
                                </svg>
                                3-5 years
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.4375 5.88477C7.7355 6.07677 7.3125 6.61602 7.3125 7.12452C7.3125 7.63302 7.7355 8.17227 8.4375 8.36352V5.88477ZM9.5625 9.63552V12.1135C10.2645 11.9223 10.6875 11.383 10.6875 10.8745C10.6875 10.366 10.2645 9.82677 9.5625 9.63552Z"
                                    fill="#023047"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9ZM9 3.9375C9.14918 3.9375 9.29226 3.99676 9.39775 4.10225C9.50324 4.20774 9.5625 4.35082 9.5625 4.5V4.73775C10.785 4.95675 11.8125 5.8755 11.8125 7.125C11.8125 7.27418 11.7532 7.41726 11.6477 7.52275C11.5423 7.62824 11.3992 7.6875 11.25 7.6875C11.1008 7.6875 10.9577 7.62824 10.8523 7.52275C10.7468 7.41726 10.6875 7.27418 10.6875 7.125C10.6875 6.6165 10.2645 6.07725 9.5625 5.88525V8.48775C10.785 8.70675 11.8125 9.6255 11.8125 10.875C11.8125 12.1245 10.785 13.0433 9.5625 13.2623V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V13.2623C7.215 13.0433 6.1875 12.1245 6.1875 10.875C6.1875 10.7258 6.24676 10.5827 6.35225 10.4773C6.45774 10.3718 6.60082 10.3125 6.75 10.3125C6.89918 10.3125 7.04226 10.3718 7.14775 10.4773C7.25324 10.5827 7.3125 10.7258 7.3125 10.875C7.3125 11.3835 7.7355 11.9228 8.4375 12.114V9.51225C7.215 9.29325 6.1875 8.3745 6.1875 7.125C6.1875 5.8755 7.215 4.95675 8.4375 4.73775V4.5C8.4375 4.35082 8.49676 4.20774 8.60225 4.10225C8.70774 3.99676 8.85082 3.9375 9 3.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                {curSym} 5k to {curSym} 6k USD
                              </li>
                            </ul>
                          </div>
                          <div className="pe-xl-5">
                            <p className="mb-0 ct_fs_14 ct_darkblue_text">
                              24 March 2025
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                          <button
                            className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 px-4"
                            data-bs-target="#ct_job_details_modal"
                            data-bs-toggle="modal"
                          >
                            Apply Now
                          </button>
                          <div className="ct_icon_heart_50">
                            <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                          </div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div className="col-lg-6 ct_mb_60">
                  <div className="ct_learning_card_learning">
                    <figure className="mb-0">
                      <div className="d-flex align-items-center gap-2 justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <div className="ct_feature_job_icon bg-white">
                            <img src="../assets/img/Featured_Jobs_icon_2.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                              CodeNest
                            </h4>
                            <p className="d-flex align-items-center gap-2 mb-0 ct_fs_14 ct_darkblue_text">
                              <svg
                                width="14"
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                  fill="#023047"
                                />
                              </svg>
                              London, England
                            </p>
                          </div>
                        </div>
                        <div className="pe-xl-5">
                          <button
                            className="ct_badge ct_border_radius_5 border-0 ct_white_nowrap"
                            style={{ backgroundColor: "#FFB703" }}
                          >
                            Full-Time
                          </button>
                        </div>
                      </div>
                      <figcaption className="ct_mt_30">
                        <h4
                          className="ct_fs_20 mb-3 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Senior full stack engineer, User onboarding
                        </h4>
                        <p className="mb-0" style={{ maxWidth: "365px" }}>
                          Drive seamless first impressions by building
                          intuitive onboarding flows that convert.
                        </p>

                        <div className="d-flex align-items-center gap-2 pt-3 justify-content-between">
                          <div>
                            <ul>
                              <li className="d-flex align-items-center gap-2">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                UI/UX Design
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                    fill="#023047"
                                  />
                                </svg>
                                3-5 years
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.4375 5.88477C7.7355 6.07677 7.3125 6.61602 7.3125 7.12452C7.3125 7.63302 7.7355 8.17227 8.4375 8.36352V5.88477ZM9.5625 9.63552V12.1135C10.2645 11.9223 10.6875 11.383 10.6875 10.8745C10.6875 10.366 10.2645 9.82677 9.5625 9.63552Z"
                                    fill="#023047"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9ZM9 3.9375C9.14918 3.9375 9.29226 3.99676 9.39775 4.10225C9.50324 4.20774 9.5625 4.35082 9.5625 4.5V4.73775C10.785 4.95675 11.8125 5.8755 11.8125 7.125C11.8125 7.27418 11.7532 7.41726 11.6477 7.52275C11.5423 7.62824 11.3992 7.6875 11.25 7.6875C11.1008 7.6875 10.9577 7.62824 10.8523 7.52275C10.7468 7.41726 10.6875 7.27418 10.6875 7.125C10.6875 6.6165 10.2645 6.07725 9.5625 5.88525V8.48775C10.785 8.70675 11.8125 9.6255 11.8125 10.875C11.8125 12.1245 10.785 13.0433 9.5625 13.2623V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V13.2623C7.215 13.0433 6.1875 12.1245 6.1875 10.875C6.1875 10.7258 6.24676 10.5827 6.35225 10.4773C6.45774 10.3718 6.60082 10.3125 6.75 10.3125C6.89918 10.3125 7.04226 10.3718 7.14775 10.4773C7.25324 10.5827 7.3125 10.7258 7.3125 10.875C7.3125 11.3835 7.7355 11.9228 8.4375 12.114V9.51225C7.215 9.29325 6.1875 8.3745 6.1875 7.125C6.1875 5.8755 7.215 4.95675 8.4375 4.73775V4.5C8.4375 4.35082 8.49676 4.20774 8.60225 4.10225C8.70774 3.99676 8.85082 3.9375 9 3.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                {curSym} 5k to {curSym} 6k USD
                              </li>
                            </ul>
                          </div>
                          <div className="pe-xl-5">
                            <p className="mb-0 ct_fs_14 ct_darkblue_text">
                              24 March 2025
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                          <button
                            className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 px-4"
                            data-bs-target="#ct_job_details_modal"
                            data-bs-toggle="modal"
                          >
                            Apply Now
                          </button>
                          <div className="ct_icon_heart_50">
                            <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                          </div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div className="col-lg-6 ct_mb_60">
                  <div className="ct_learning_card_learning">
                    <figure className="mb-0">
                      <div className="d-flex align-items-center gap-2 justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <div className="ct_feature_job_icon bg-white">
                            <img src="../assets/img/Featured_Jobs_icon_2.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                              CodeNest
                            </h4>
                            <p className="d-flex align-items-center gap-2 mb-0 ct_fs_14 ct_darkblue_text">
                              <svg
                                width="14"
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                  fill="#023047"
                                />
                              </svg>
                              London, England
                            </p>
                          </div>
                        </div>
                        <div className="pe-xl-5">
                          <button
                            className="ct_badge ct_border_radius_5 border-0 ct_white_nowrap"
                            style={{ backgroundColor: "#FFB703" }}
                          >
                            Full-Time
                          </button>
                        </div>
                      </div>
                      <figcaption className="ct_mt_30">
                        <h4
                          className="ct_fs_20 mb-3 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Senior full stack engineer, User onboarding
                        </h4>
                        <p className="mb-0" style={{ maxWidth: "365px" }}>
                          Drive seamless first impressions by building
                          intuitive onboarding flows that convert.
                        </p>

                        <div className="d-flex align-items-center gap-2 pt-3 justify-content-between">
                          <div>
                            <ul>
                              <li className="d-flex align-items-center gap-2">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                UI/UX Design
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                    fill="#023047"
                                  />
                                </svg>
                                3-5 years
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.4375 5.88477C7.7355 6.07677 7.3125 6.61602 7.3125 7.12452C7.3125 7.63302 7.7355 8.17227 8.4375 8.36352V5.88477ZM9.5625 9.63552V12.1135C10.2645 11.9223 10.6875 11.383 10.6875 10.8745C10.6875 10.366 10.2645 9.82677 9.5625 9.63552Z"
                                    fill="#023047"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9ZM9 3.9375C9.14918 3.9375 9.29226 3.99676 9.39775 4.10225C9.50324 4.20774 9.5625 4.35082 9.5625 4.5V4.73775C10.785 4.95675 11.8125 5.8755 11.8125 7.125C11.8125 7.27418 11.7532 7.41726 11.6477 7.52275C11.5423 7.62824 11.3992 7.6875 11.25 7.6875C11.1008 7.6875 10.9577 7.62824 10.8523 7.52275C10.7468 7.41726 10.6875 7.27418 10.6875 7.125C10.6875 6.6165 10.2645 6.07725 9.5625 5.88525V8.48775C10.785 8.70675 11.8125 9.6255 11.8125 10.875C11.8125 12.1245 10.785 13.0433 9.5625 13.2623V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V13.2623C7.215 13.0433 6.1875 12.1245 6.1875 10.875C6.1875 10.7258 6.24676 10.5827 6.35225 10.4773C6.45774 10.3718 6.60082 10.3125 6.75 10.3125C6.89918 10.3125 7.04226 10.3718 7.14775 10.4773C7.25324 10.5827 7.3125 10.7258 7.3125 10.875C7.3125 11.3835 7.7355 11.9228 8.4375 12.114V9.51225C7.215 9.29325 6.1875 8.3745 6.1875 7.125C6.1875 5.8755 7.215 4.95675 8.4375 4.73775V4.5C8.4375 4.35082 8.49676 4.20774 8.60225 4.10225C8.70774 3.99676 8.85082 3.9375 9 3.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                {curSym} 5k to {curSym} 6k USD
                              </li>
                            </ul>
                          </div>
                          <div className="pe-xl-5">
                            <p className="mb-0 ct_fs_14 ct_darkblue_text">
                              24 March 2025
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                          <button
                            className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 px-4"
                            data-bs-target="#ct_job_details_modal"
                            data-bs-toggle="modal"
                          >
                            Apply Now
                          </button>
                          <div className="ct_icon_heart_50">
                            <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                          </div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div className="col-lg-6 ct_mb_60">
                  <div className="ct_learning_card_learning">
                    <figure className="mb-0">
                      <div className="d-flex align-items-center gap-2 justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <div className="ct_feature_job_icon bg-white">
                            <img src="../assets/img/Featured_Jobs_icon_2.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                              CodeNest
                            </h4>
                            <p className="d-flex align-items-center gap-2 mb-0 ct_fs_14 ct_darkblue_text">
                              <svg
                                width="14"
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                  fill="#023047"
                                />
                              </svg>
                              London, England
                            </p>
                          </div>
                        </div>
                        <div className="pe-xl-5">
                          <button
                            className="ct_badge ct_border_radius_5 border-0 ct_white_nowrap"
                            style={{ backgroundColor: "#FFB703" }}
                          >
                            Full-Time
                          </button>
                        </div>
                      </div>
                      <figcaption className="ct_mt_30">
                        <h4
                          className="ct_fs_20 mb-3 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Senior full stack engineer, User onboarding
                        </h4>
                        <p className="mb-0" style={{ maxWidth: "365px" }}>
                          Drive seamless first impressions by building
                          intuitive onboarding flows that convert.
                        </p>

                        <div className="d-flex align-items-center gap-2 pt-3 justify-content-between">
                          <div>
                            <ul>
                              <li className="d-flex align-items-center gap-2">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                UI/UX Design
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                    fill="#023047"
                                  />
                                </svg>
                                3-5 years
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.4375 5.88477C7.7355 6.07677 7.3125 6.61602 7.3125 7.12452C7.3125 7.63302 7.7355 8.17227 8.4375 8.36352V5.88477ZM9.5625 9.63552V12.1135C10.2645 11.9223 10.6875 11.383 10.6875 10.8745C10.6875 10.366 10.2645 9.82677 9.5625 9.63552Z"
                                    fill="#023047"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9ZM9 3.9375C9.14918 3.9375 9.29226 3.99676 9.39775 4.10225C9.50324 4.20774 9.5625 4.35082 9.5625 4.5V4.73775C10.785 4.95675 11.8125 5.8755 11.8125 7.125C11.8125 7.27418 11.7532 7.41726 11.6477 7.52275C11.5423 7.62824 11.3992 7.6875 11.25 7.6875C11.1008 7.6875 10.9577 7.62824 10.8523 7.52275C10.7468 7.41726 10.6875 7.27418 10.6875 7.125C10.6875 6.6165 10.2645 6.07725 9.5625 5.88525V8.48775C10.785 8.70675 11.8125 9.6255 11.8125 10.875C11.8125 12.1245 10.785 13.0433 9.5625 13.2623V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V13.2623C7.215 13.0433 6.1875 12.1245 6.1875 10.875C6.1875 10.7258 6.24676 10.5827 6.35225 10.4773C6.45774 10.3718 6.60082 10.3125 6.75 10.3125C6.89918 10.3125 7.04226 10.3718 7.14775 10.4773C7.25324 10.5827 7.3125 10.7258 7.3125 10.875C7.3125 11.3835 7.7355 11.9228 8.4375 12.114V9.51225C7.215 9.29325 6.1875 8.3745 6.1875 7.125C6.1875 5.8755 7.215 4.95675 8.4375 4.73775V4.5C8.4375 4.35082 8.49676 4.20774 8.60225 4.10225C8.70774 3.99676 8.85082 3.9375 9 3.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                {curSym} 5k to {curSym} 6k USD
                              </li>
                            </ul>
                          </div>
                          <div className="pe-xl-5">
                            <p className="mb-0 ct_fs_14 ct_darkblue_text">
                              24 March 2025
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                          <button
                            className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 px-4"
                            data-bs-target="#ct_job_details_modal"
                            data-bs-toggle="modal"
                          >
                            Apply Now
                          </button>
                          <div className="ct_icon_heart_50">
                            <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                          </div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
                <div className="col-lg-6 ct_mb_60">
                  <div className="ct_learning_card_learning">
                    <figure className="mb-0">
                      <div className="d-flex align-items-center gap-2 justify-content-between">
                        <div className="d-flex align-items-center gap-4">
                          <div className="ct_feature_job_icon bg-white">
                            <img src="../assets/img/Featured_Jobs_icon_3.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_20 mb-2 ct_darkblue_text">
                              CodeNest
                            </h4>
                            <p className="d-flex align-items-center gap-2 mb-0 ct_fs_14 ct_darkblue_text">
                              <svg
                                width="14"
                                height="17"
                                viewBox="0 0 14 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                  fill="#023047"
                                />
                              </svg>
                              London, England
                            </p>
                          </div>
                        </div>
                        <div className="pe-xl-5">
                          <button
                            className="ct_badge ct_border_radius_5 border-0 ct_white_nowrap"
                            style={{ backgroundColor: "#FFB703" }}
                          >
                            Full-Time
                          </button>
                        </div>
                      </div>
                      <figcaption className="ct_mt_30">
                        <h4
                          className="ct_fs_20 mb-3 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Senior full stack engineer, User onboarding
                        </h4>
                        <p className="mb-0" style={{ maxWidth: "365px" }}>
                          Drive seamless first impressions by building
                          intuitive onboarding flows that convert.
                        </p>

                        <div className="d-flex align-items-center gap-2 pt-3 justify-content-between">
                          <div>
                            <ul>
                              <li className="d-flex align-items-center gap-2">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.8067 4.69305C13.58 4.91971 13.36 5.13971 13.3533 5.35971C13.3333 5.57305 13.56 5.79305 13.7733 5.99971C14.0933 6.33305 14.4067 6.63305 14.3933 6.95971C14.38 7.28638 14.04 7.62638 13.7 7.95971L10.9467 10.7197L10 9.77305L12.8333 6.94638L12.1933 6.30638L11.2467 7.24638L8.74667 4.74638L11.3067 2.19305C11.5667 1.93305 12 1.93305 12.2467 2.19305L13.8067 3.75305C14.0667 3.99971 14.0667 4.43305 13.8067 4.69305ZM2 11.4997L8.37333 5.11971L10.8733 7.61971L4.5 13.9997H2V11.4997Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                UI/UX Design
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.33625 15.6082C5.79075 15.9832 6.26475 16.326 6.75 16.6605C7.2363 16.3304 7.70799 15.9793 8.16375 15.6082C8.9235 14.9844 9.63851 14.308 10.3035 13.584C11.8365 11.9077 13.5 9.47775 13.5 6.75C13.5 5.86358 13.3254 4.98583 12.9862 4.16689C12.647 3.34794 12.1498 2.60382 11.523 1.97703C10.8962 1.35023 10.1521 0.853032 9.33311 0.513813C8.51417 0.174594 7.63642 0 6.75 0C5.86358 0 4.98583 0.174594 4.16689 0.513813C3.34794 0.853032 2.60382 1.35023 1.97703 1.97703C1.35023 2.60382 0.853032 3.34794 0.513813 4.16689C0.174594 4.98583 -1.32087e-08 5.86358 0 6.75C0 9.47775 1.6635 11.907 3.1965 13.584C3.86146 14.3083 4.57647 14.9842 5.33625 15.6082ZM6.75 9.1875C6.10353 9.1875 5.48355 8.93069 5.02643 8.47357C4.56931 8.01645 4.3125 7.39646 4.3125 6.75C4.3125 6.10353 4.56931 5.48355 5.02643 5.02643C5.48355 4.56931 6.10353 4.3125 6.75 4.3125C7.39647 4.3125 8.01645 4.56931 8.47357 5.02643C8.93069 5.48355 9.1875 6.10353 9.1875 6.75C9.1875 7.39646 8.93069 8.01645 8.47357 8.47357C8.01645 8.93069 7.39647 9.1875 6.75 9.1875Z"
                                    fill="#023047"
                                  />
                                </svg>
                                3-5 years
                              </li>
                              <li className="d-flex align-items-center gap-2 mt-2">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.4375 5.88477C7.7355 6.07677 7.3125 6.61602 7.3125 7.12452C7.3125 7.63302 7.7355 8.17227 8.4375 8.36352V5.88477ZM9.5625 9.63552V12.1135C10.2645 11.9223 10.6875 11.383 10.6875 10.8745C10.6875 10.366 10.2645 9.82677 9.5625 9.63552Z"
                                    fill="#023047"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9ZM9 3.9375C9.14918 3.9375 9.29226 3.99676 9.39775 4.10225C9.50324 4.20774 9.5625 4.35082 9.5625 4.5V4.73775C10.785 4.95675 11.8125 5.8755 11.8125 7.125C11.8125 7.27418 11.7532 7.41726 11.6477 7.52275C11.5423 7.62824 11.3992 7.6875 11.25 7.6875C11.1008 7.6875 10.9577 7.62824 10.8523 7.52275C10.7468 7.41726 10.6875 7.27418 10.6875 7.125C10.6875 6.6165 10.2645 6.07725 9.5625 5.88525V8.48775C10.785 8.70675 11.8125 9.6255 11.8125 10.875C11.8125 12.1245 10.785 13.0433 9.5625 13.2623V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V13.2623C7.215 13.0433 6.1875 12.1245 6.1875 10.875C6.1875 10.7258 6.24676 10.5827 6.35225 10.4773C6.45774 10.3718 6.60082 10.3125 6.75 10.3125C6.89918 10.3125 7.04226 10.3718 7.14775 10.4773C7.25324 10.5827 7.3125 10.7258 7.3125 10.875C7.3125 11.3835 7.7355 11.9228 8.4375 12.114V9.51225C7.215 9.29325 6.1875 8.3745 6.1875 7.125C6.1875 5.8755 7.215 4.95675 8.4375 4.73775V4.5C8.4375 4.35082 8.49676 4.20774 8.60225 4.10225C8.70774 3.99676 8.85082 3.9375 9 3.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                {curSym} 5k to {curSym} 6k USD
                              </li>
                            </ul>
                          </div>
                          <div className="pe-xl-5">
                            <p className="mb-0 ct_fs_14 ct_darkblue_text">
                              24 March 2025
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_33">
                          <button
                            className="ct_yellow_btn ct_outline_dark_blue_btn ct_border_radius_20 ct_h_44 px-4"
                            data-bs-target="#ct_job_details_modal"
                            data-bs-toggle="modal"
                          >
                            Apply Now
                          </button>
                          <div className="ct_icon_heart_50">
                            <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                          </div>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          class="ct_looking_for_work_bg      ct_p_111_y_106"
          data-aos="fade-left"
          data-aos-duration="1500"
          style={{ backgroundColor: "#219EBC" }}
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-4">
                Discover Roles at Game-Changing Companies
              </h4>
              <p class="mb-0 ct_fs_18">
                Discover roles from innovative brands shaping the future of
                work.
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
                Explore Jobs
              </a>
            </div>
          </div>
        </section>

        <section className="ct_pt_130 ct_px_40 ct_pb_90">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h2 className="ct_fs_32 text-center ct_mb_60">
                  Recommended Jobs
                </h2>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xxl-6  col-xl-6  mb-5"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div
                  className="ct_feature_job_card ct_pt_60_px_60_pb_75"
                  style={{ backgroundColor: "hsl(199deg 64% 73% / 50%)" }}
                >
                  <div className="ct_feature_job_icon bg-white">
                    <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                  </div>
                  <div>
                    <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                      <div className="d-flex align-items-center gap-4 ">
                        <span
                          className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "var(--yellow)" }}
                        >
                          Full-Time
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                          style={{ backgroundColor: "var(--dark_blue)" }}
                        >
                          Website Development
                        </span>
                      </div>
                      <div className="ct_icon_30px_12">
                        <i class="fa-regular fa-bookmark"></i>
                      </div>
                    </div>
                    <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                      Senior full stack engineer, User onboarding
                    </h4>
                    <ul className="ct_feature_job_key_points">
                      <li>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                            fill="#023047"
                          />
                        </svg>
                        <span className="ct_darkblue_text">3-5 years</span>
                      </li>
                      <li>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                            fill="#023047"
                          />
                        </svg>
                        <span className="ct_darkblue_text">{curSym} 5k to {curSym} 6k USD</span>
                      </li>
                      <li>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                            fill="#023047"
                          />
                        </svg>
                        <span className="ct_darkblue_text">
                          London, England
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="col-xxl-6  col-xl-6  mb-5"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div
                  className="ct_feature_job_card ct_pt_60_px_60_pb_75"
                  style={{ backgroundColor: "hsl(43deg 100% 51% / 50%)" }}
                >
                  <div className="ct_feature_job_icon bg-white">
                    <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                  </div>
                  <div>
                    <div className="d-flex align-items-center justify-content-between ct_mb_20">
                      <div className="d-flex align-items-center gap-4 ">
                        <span
                          className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "var(--yellow)" }}
                        >
                          Full-Time
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 text-white"
                          style={{ backgroundColor: "var(--dark_blue)" }}
                        >
                          Website Development
                        </span>
                      </div>
                      <div className="ct_icon_30px_12">
                        <i class="fa-regular fa-bookmark"></i>
                      </div>
                    </div>
                    <h4 className="ct_fs_22 ct_darkblue_text ct_mb_20">
                      Senior full stack engineer, User onboarding
                    </h4>
                    <ul className="ct_feature_job_key_points">
                      <li>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                            fill="#023047"
                          />
                        </svg>
                        <span className="ct_darkblue_text">3-5 years</span>
                      </li>
                      <li>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                            fill="#023047"
                          />
                        </svg>
                        <span className="ct_darkblue_text">{curSym} 5k to {curSym} 6k USD</span>
                      </li>
                      <li>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V6C1.5 5.1675 2.1675 4.5 3 4.5H6V3C6 2.1675 6.6675 1.5 7.5 1.5ZM10.5 4.5V3H7.5V4.5H10.5Z"
                            fill="#023047"
                          />
                        </svg>
                        <span className="ct_darkblue_text">
                          London, England
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class=" ct_px_40 ct_py_130 pt-0">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div class="ct_how_work_img">
                  <img
                    src="../assets/img/work_detail_banner_left.png"
                    alt=""
                    style={{ objectFit: "cover", objectPosition: "top" }}
                  />
                </div>
              </div>
              <div
                class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div class="ct_how_work_content">
                  <h4 class="ct_fs_24 ct_darkblue_text">
                    Which Nuvio Plans Fit Your Freelance Goals?
                  </h4>
                  <h3 class="ct_fs_32 ct_darkblue_text ">
                    Choose a path that grows with you
                  </h3>
                </div>
                <div class="row mt-5">
                  <div
                    class="col-lg-4 ct_cursor_pointer"
                    onClick={() => navigate(coachPaths?.NuGlowSubscription)}
                  >
                    <div class="ct_how_work_card">
                      <img
                        src="../assets/img/noto_fire_12.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                          NuGlow
                        </h5>
                        <p
                          class="mb-0 ct_fs_16 ct_darkblue_text"
                          style={{ maxWidth: "248px" }}
                        >
                          A starter path to help you gain visibility, apply to
                          curated jobs, and build your first wins
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-4 ct_cursor_pointer"
                    onClick={() => navigate(coachPaths?.NuForgeSubscription)}
                  >
                    <div class="ct_how_work_card ">
                      <img
                        src="../assets/img/noto-v1_helicopter.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_orange_text mb-4">
                          NuForge
                        </h5>
                        <p
                          class="mb-0 ct_fs_16 ct_darkblue_text"
                          style={{ maxWidth: "248px" }}
                        >
                          Designed for active freelancers looking to refine
                          their offer and land bigger project
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-4 ct_cursor_pointer"
                    onClick={() => navigate(coachPaths?.NuStarSubscription)}
                  >
                    <div class="ct_how_work_card ">
                      <img
                        src="../assets/img/fluent-emoji-flat_small-airplane.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_darksky_blue_text mb-4">
                          NuStar
                        </h5>
                        <p
                          class="mb-0 ct_fs_16 ct_darkblue_text"
                          style={{ maxWidth: "263px" }}
                        >
                          Our most advanced plan for experienced freelancers
                          with premium exposure, and early job
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="ct_px_40  ct_mb_100"
          data-aos="fade-down"
          data-aos-duration="1500"
        >
          <div className="container-fluid">
            {/* convert into slider */}
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-4">
                <div class="ct_testimonial_review_card h-100 d-grid">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                      <div class="d-flex align-items-center gap-1">
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      </div>
                      <p className="mb-0 ct_fs_16">20th April, 2025</p>
                    </div>
                    <p className="mb-0 " style={{ maxWidth: "295px" }}>
                      The expert sessions and networking inside NuForge are next level. I finally feel part of a serious community that pushes me to grow.
                    </p>
                  </div>
                  <div className="mt-auto">
                    <div class="d-flex align-items-center gap-3 ct_mt_40">
                      <img
                        src="/assets/img/Ellipse 24.png"
                        class="ct_img_60 "
                        alt=""
                      />
                      <div>
                        <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                          Alex Robertson
                        </h5>
                        <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-4">
                <div class="ct_testimonial_review_card h-100 d-grid">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                      <div class="d-flex align-items-center gap-1">
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      </div>

                      <p className="mb-0 ct_fs_16">20th April, 2025</p>
                    </div>
                    <p className="mb-0 " style={{ maxWidth: "295px" }}>
                      With NuForge, I refined my services, rebranded my profile, and doubled my client reach in just a few weeks. Totally worth it!
                    </p>
                  </div>
                  <div className="mt-auto">
                    <div class="d-flex align-items-center gap-3 ct_mt_40">
                      <img
                        src="/assets/img/Ellipse 24 (1).png"
                        class="ct_img_60 "
                        alt=""
                      />
                      <div>
                        <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                          Olivia Brooks
                        </h5>
                        <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-4">
                <div class="ct_testimonial_review_card h-100 d-grid">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                      <div class="d-flex align-items-center gap-1">
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      </div>

                      <p className="mb-0 ct_fs_16">20th April, 2025</p>
                    </div>
                    <p className="mb-0 " style={{ maxWidth: "295px" }}>
                      NuForge helped me position myself for higher-paying clients by improving my portfolio and strategy.
                    </p>
                  </div>
                  <div className="mt-auto">
                    <div class="d-flex align-items-center gap-3 ct_mt_40">
                      <img
                        src="/assets/img/Ellipse 24 (2).png"
                        class="ct_img_60 "
                        alt=""
                      />
                      <div>
                        <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                          James Thornton
                        </h5>
                        <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div
          class="modal fade ct_submit_modal"
          id="ct_submit_modal"
          tabindex="-1"
          aria-labelledby="ct_submit_modalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body py-5">
                <div class="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div class="text-center">
                  <h4 class="ct_fs_20 ">Application Submitted</h4>
                  <p>
                    Thanks for applying to become a coach on Nuvio CoachHUB. Our
                    team is currently reviewing your application
                  </p>
                </div>
                <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <a class="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575">
                    View Coaches
                  </a>
                  <button
                    class="ct_yellow_btn ct_h_48  px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MenuLayout>

      <div
        className="modal modal-xl ct_congratulation_modal_fade"
        id="ct_job_details_modal"
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered ct_modal-dialog"
          style={{ maxWidth: "1440px" }}
        >
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-sm-5 px-3 pt-0 pb-5">
              <div className="row">
                <div className="col-xl-8 col-lg-8 mb-4 mb-lg-0">
                  <div className="">
                    <div className="d-flex align-items-start justify-content-between gap-3 ct_flex_col_1199  ct_mb_60">
                      <div>
                        <h4 className="ct_fs_32 mb-0 ct_darkblue_text">
                          UI/UX Designer
                        </h4>
                        <div className="d-flex align-items-center gap-3  mt-4 ct_flex_col_575">
                          <div
                            class="ct_feature_job_icon"
                            style={{ width: "80px", height: "80px" }}
                          >
                            <img src="assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-3 ">
                              <h4 className="ct_fs_18 mb-0 ct_darksky_blue_text">
                                CodeNest{" "}
                              </h4>
                              <div class="ct_fs_14 d-flex align-items-center gap-1">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                London, England
                              </div>
                            </div>
                            <div class="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                Full-Time
                              </span>
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                Remote
                              </span>
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                2-4 Years
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center  gap-3 ">
                        <button
                          className="ct_yellow_btn ct_sky_blue_btn ct_white_nowrap ct_border_radius_20 ct_h_44 px-5"
                          data-bs-target="#ct_aaply_for_job"
                          data-bs-toggle="modal"
                        >
                          Apply Now
                        </button>
                        <div className="ct_icon_heart_50">
                          <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                        </div>
                        <div className="ct_icon_heart_50">
                          <i class="fa-solid fa-share-nodes ct_darkblue_text"></i>
                        </div>
                      </div>
                    </div>
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      About this role
                    </h4>
                    <p
                      className="ct_fs_20_new ct_para_scroll ct_custom_scroll ct_darkblue_text"
                      style={{ maxWidth: "820px" }}
                    >
                      As a UI/UX designer on CodeNest, you’ll focus on design
                      user- friendly on several platform (web, mobile,
                      dashboards, etc) to our user needs. Your innovation
                      solution will enhance the user experience on several
                      platforms. Join us and let’s making impact on user
                      engagement at CodeNest.
                    </p>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Qualification
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        At least 2-4 years of relevant experience in product
                        design or related roles.
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Knowledge of design validation, either through
                        quantitative or qualitative research.
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Have good knowledge using Figma and Figjam
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Experience with analytics tools to gather data from
                        users
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Responsibility
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        Create design and user journey on every features and
                        product/business units across multiple devices (Web
                        +App)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Identifying design problems through user journey and
                        devising elegant solutions
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Develop low and hi fidelity designs, user experience
                        flow, & prototype, translate it into highly- polished
                        visual composites following style and brand guidelines
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Brainstorm and works together with Design Lead, UX
                        Engineers, and PMS to execute a design sprint on
                        specific story or task
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Requirement
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        Proven work experience as a UI/UX Designer or similar
                        role
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Strond portfolio of design projects (web/ mobile)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Proficiency in design and prototyping tools such as
                        Figma, Adobe XD, Sketch, or similar
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Good understanding of HTML/CSS (Knowledge of front-end
                        development is a plus)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Ability to think creatively and deliver within deadlines
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Excellent communication and teamwork skills
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 mb-4 mb-lg-0 ps-lg-5">
                  <div>
                    <h4 className="ct_fs_24_new mb-4">Similar Jobs</h4>
                    <ul>
                      <li>
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_6.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Lead UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_3.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Sr. UX Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_2.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Jr. UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_56">
                    <h4 className="ct_fs_24_new mb-4">
                      Other Jobs From CodeNest
                    </h4>
                    <ul>
                      <li>
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Lead UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Sr. UX Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Jr. UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-lg ct_congratulation_modal_fade"
        id="ct_aaply_for_job"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="ct_fs_32 ct_darkblue_text mb-0">UI/UX Designer</h4>
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-0 ct_mt_60 pt-0">
              <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="e.g"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Email Address
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Email address"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Phone Number
                      </label>
                      <input
                        type="number"
                        className="form-control ct_input"
                        placeholder="Phone number"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Expected Salary (in local currency)
                      </label>
                      <input
                        type="number"
                        className="form-control ct_input"
                        placeholder="Expected salary"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Work
                      </label>
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input">
                          <option>Hourly</option>
                          <option>Hourly</option>
                          <option>Hourly</option>
                          <option>Hourly</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Current Position (if unemployed, then “Unemployed”)
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Current position"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Linkedin Profile Link
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Link"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Porfolio Link
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Link"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Cover Letter
                      </label>
                      <textarea
                        className="form-control ct_input h-auto"
                        rows={4}
                        placeholder="Type here..."
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Upload Resume
                      </label>
                      <div
                        class="ct_upload_product_main ct_upload_product_main_180 "
                        style={{ height: "118px" }}
                      >
                        <svg
                          width="33"
                          height="33"
                          viewBox="0 0 33 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.87174 22.0167C4.26376 20.9403 3.20508 19.1073 3.20508 17.027C3.20508 13.9023 5.59376 11.3354 8.64473 11.0528C9.26883 7.25653 12.5654 4.36035 16.5384 4.36035C20.5114 4.36035 23.808 7.25653 24.4321 11.0528C27.4831 11.3354 29.8717 13.9023 29.8717 17.027C29.8717 19.1073 28.8131 20.9403 27.2051 22.0167M11.2051 21.6937L16.5384 16.3604M16.5384 16.3604L21.8717 21.6937M16.5384 16.3604V28.3604"
                            stroke="#9CA3AF"
                            stroke-width="2.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>

                        <p class="text-center ct_fs_18 ct_text_op_07 mb-0">
                          Upload your resume here
                        </p>
                        <label for="ct_upload_product">
                          <input
                            type="file"
                            name=""
                            id="ct_upload_product"
                            class="d-none"
                          />
                        </label>
                      </div>

                      <div class="ct_single_uploaded_img mt-3 d-none">
                        <img
                          src="assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                          alt=""
                        />
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                  <button
                    className="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 py-2"
                    style={{ borderColorL: "#53586252" }}
                    type="button"
                  >
                    Save Draft
                  </button>
                  <button
                    className="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                    data-bs-target="#ct_submit_modal"
                    data-bs-toggle="modal"
                    type="button"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobDetail